import React from 'react';
import { ArrowRight } from 'lucide-react';

interface ComingSoonButtonProps {
  children: React.ReactNode;
  onClick: () => void;
  variant?: 'primary' | 'secondary';
  className?: string;
  showArrow?: boolean;
}

const ComingSoonButton: React.FC<ComingSoonButtonProps> = ({ 
  children, 
  onClick, 
  variant = 'primary',
  className = '',
  showArrow = false
}) => {
  const baseClasses = "px-6 py-3 rounded-lg font-medium transition-all duration-300 flex items-center space-x-2 group";
  
  const variantClasses = {
    primary: "gradient-bg text-white hover:shadow-xl",
    secondary: "glass-effect text-white hover:bg-white/10"
  };

  return (
    <button 
      onClick={onClick}
      className={`${baseClasses} ${variantClasses[variant]} ${className}`}
    >
      <span>{children}</span>
      {showArrow && (
        <ArrowRight size={20} className="group-hover:translate-x-1 transition-transform duration-200" />
      )}
    </button>
  );
};

export default ComingSoonButton; 